/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React, { useState } from "react";
import FormScopeDefiner from "../Component/Forms/FormScopeDefiner";
import ThemeControls from "../Component/AllThemesControl";
// import contextJson from './masterJson.json';
import SubTable from "./SubTable";

 ;

function Create(props) {
    const {useStyles} = ThemeControls;
    const classes=useStyles();
    const contextClasses = classes.topSpace;
    const contextObjective = "create";
    let sideImageData={};
    let fieldsData=[];
    const {id, field_type,fields, field_disabled_Edit,field_apipath, field_id, field_label, field_placeholder,field_disabled, field_value,field_option_src, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,onChange,field_mandatory } = props;
    // let {masterData} = React.useContext(MasterContext);
    const contextJson=fields;
    const apiContextVar = field_apipath.apiContext;
    const apiContextObj = {};
    apiContextObj.apiContextSave=field_apipath.apiContext;
    apiContextObj.apiContext=field_apipath.apiContext;
    apiContextObj.type=field_apipath.type;
    apiContextObj.id=field_apipath.id;
    apiContextObj.action=field_apipath.action;
    const [subresponse, setSubResponse]=useState(false);
    // alert(id)
    Object.keys(contextJson).forEach((key,index) =>{
      if(key!=="xioFEConfig"){
        contextJson[key].fields.map((field)=>{
          if(field.field_type==="hidden"){
            if(field.field_default_value){
              field.field_value = field.field_default_value
              field.id = id;
            }else{
              field.field_value = field.field_value;
              field.id = id;
            }
          } else if(field.field_default_value){
            field.field_value = field.field_default_value
            field.id = id
          } else{
            field.field_value = "";
            field.field_apipath = "";
            field.id = id ;
          }
          return field; // <-- add this return statement
        });
        
        // =---sideIMage---dataAssing--->
        if(contextJson['xioFEConfig']&&contextJson['xioFEConfig'].sideImageData){
          sideImageData=contextJson['xioFEConfig'].sideImageData;
        }
      }
    });
    Object.keys(contextJson).forEach((key) => {
      if (key !== "xioFEConfig") {
        const filteredFields = contextJson[key].fields.filter(
          (field) => field.field_type !== 'hidden'
        );
    
        fieldsData = fieldsData.concat(
          filteredFields.map((field, index) => ({
            key: `${index + 1}`,
            title: field.field_label,
            dataIndex: field.field_id,
            field_options: field.field_type === 'select'?field.field_options:null
          }))
        );
      }
    });
    
    return (
      <>
          <FormScopeDefiner value={{id,contextJson,apiContextObj,contextClasses,contextObjective,setSubResponse}}/>
          <SubTable fieldsData={fieldsData} contextJson={contextJson} apiPath={apiContextVar} apiContextObj={apiContextObj} id={id} subresponse={subresponse} setSubResponse={setSubResponse}/>
      </>
    )
  }

  export default Create;  
  